import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/contact-received/contact-received.client.tsx");
